// extracted by mini-css-extract-plugin
export default {"inputMain":"RadioInput_inputMain__Y7+LU"};